import { browserTracingIntegration, init as initSentry, replayIntegration } from '@sentry/vue';
import type { App } from 'vue';

// tracesSampleRate was 1.0: every transaction of every session ingested, which is volume
// rather than signal. A tenth is Sentry's own suggested starting point.
const TRACES_SAMPLE_RATE = 0.1;
const REPLAYS_SESSION_SAMPLE_RATE = 0.1;
const REPLAYS_ON_ERROR_SAMPLE_RATE = 1;

function initErrorMonitoring(app: App): void {
    const dsn = import.meta.env.VITE_SENTRY_DSN;

    // A build without a DSN is the normal local case, not a failure -- but a deployment that
    // meant to report and does not should be able to see why.
    if (!dsn) {
        console.info('Sentry: no VITE_SENTRY_DSN, error reporting is off');
        return;
    }

    initSentry({
        app,
        dsn,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
        release: import.meta.env.VITE_SENTRY_RELEASE,
        trackComponents: true,
        // replayCanvasIntegration is deliberately absent: it records this app's own surfaces,
        // a 300 DPI raster and a WebGL context, which is the heaviest thing Sentry can do here.
        integrations: [
            browserTracingIntegration(),
            replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],
        tracesSampleRate: TRACES_SAMPLE_RATE,
        replaysSessionSampleRate: REPLAYS_SESSION_SAMPLE_RATE,
        replaysOnErrorSampleRate: REPLAYS_ON_ERROR_SAMPLE_RATE,
    });
}

export { initErrorMonitoring };
